module.exports = __webpack_public_path__ + "static/media/surfconext_logo.f2fa49ad.svg";